// Fork Oito: rotas do Funil (CRM)
import {
  CONVERSATION_PERMISSIONS,
  ROLES,
} from 'dashboard/constants/permissions';
import { frontendURL } from '../../../helper/URLHelper';
import FunilPage from './FunilPage.vue';
import { funilAberto } from './funilDrawer';

const meta = { permissions: [...ROLES, ...CONVERSATION_PERMISSIONS] };
export const routes = [
  {
    path: frontendURL('accounts/:accountId/funil/fila'),
    name: 'oito_funil_fila',
    component: FunilPage,
    meta,
    // vindo de outra tela do Chatwoot: abre/fecha o painel lateral e fica onde está
    beforeEnter: (_to, from) => {
      if (!from.name) return true;
      funilAberto.value = !funilAberto.value;
      return false;
    },
  },
  {
    path: frontendURL('accounts/:accountId/funil/quadro'),
    name: 'oito_funil_quadro',
    component: FunilPage,
    meta,
  },
];
